export default __webpack_public_path__ + "static/media/mentors-2.945d5b54.jpg";